import ErrorBoundary from "../../ErrorBoundary";
import React from "react";
import BaseByMapGrid from "../../Base/BaseByMapGrid";
const keyName='DtpGrid';

export default class DtpGrid extends BaseByMapGrid {

    constructor(props) {
        super(props);
        const context = this;
        if (window.IasConfig.devMode) console.debug(`${keyName} constructor`, props);
        // context.subElementName = 'DocumentPage';
        context.tableName = `dtppnt`;
        context.idName = 'row_id';
        context.hiddenColumns=[context.idName];
    }

}